function animate(e) {
    if (!this.querySelector('.text')) {
        const text = document.createElement('span');
        text.classList.add('text');
        text.innerText = this.innerText;
        this.innerText = null;
        this.appendChild(text);
    }

    let ink = this.querySelector('.ink');

    if (!ink) {
        ink = document.createElement('span');
        ink.classList.add('ink');
        this.insertBefore(ink, this.firstChild);
    }

    ink.classList.remove('animate');

    if (!ink.offsetHeight && !ink.offsetWidth) {
        const d = Math.max(this.offsetHeight, this.offsetWidth);
        ink.style.height = `${d}px`;
        ink.style.width = `${d}px`;
    }

    const rect = this.getBoundingClientRect();

    const offset = {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
    };

    const x = e.pageX - offset.left - ink.offsetWidth / 2;
    const y = e.pageY - offset.top - ink.offsetHeight / 2;


    ink.style.top = `${y}px`;
    ink.style.left = `${x}px`;
    ink.classList.add('animate');
}

const initialize = $button => {
    if ($button.getAttribute('disabled')) {
        return false;
    }
    $button.addEventListener('click', animate);
};

export default () => {
    const $buttons = document.querySelectorAll('.sm-button');
    $buttons.forEach(initialize);
};
